module.exports = __webpack_public_path__ + "static/media/pause.d0dd8195.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pause.svg
// module id = 203
// module chunks = 0